import type { TodayInfo } from "./api/types";

const FALLBACK_TIME_ZONE = "Asia/Shanghai";

function getPart(
  parts: Intl.DateTimeFormatPart[],
  type: Intl.DateTimeFormatPartTypes,
): string {
  return parts.find((part) => part.type === type)?.value ?? "00";
}

export function buildTodayFallback(now = new Date()): TodayInfo {
  const dateParts = new Intl.DateTimeFormat("zh-CN", {
    timeZone: FALLBACK_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const timeParts = new Intl.DateTimeFormat("zh-CN", {
    timeZone: FALLBACK_TIME_ZONE,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(now);

  return {
    date_text: `${getPart(dateParts, "year")} 年 ${getPart(dateParts, "month")} 月 ${getPart(dateParts, "day")} 日`,
    time_text: `${getPart(timeParts, "hour")} 点 ${getPart(timeParts, "minute")} 分`,
    weather_location: "家",
    weather_summary:
      "今天信息暂时离线，先播报本机日期和时间；天气和后台提醒恢复网络后再读取。",
    reminders: ["恢复网络后读取后台提醒。"],
  };
}
